import { render, staticRenderFns } from "./MedicineWrhsMngtReg.vue?vue&type=template&id=594ecb6b"
import script from "./MedicineWrhsMngtReg.vue?vue&type=script&lang=js"
export * from "./MedicineWrhsMngtReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports